import * as React from 'react';
import Icons from "../../Icons";
import {getBoutiqueColor} from "../../MonCompteAction";

export interface UploadBtnProps {
  marquageId?: number;
  identifier: string,
  onUpdateInput: any,
  selectedFileName: string,
  authorizedFiles: any,
  marquageNom: string,
  surfaceId: string
}

export const UploadBtn = (props: UploadBtnProps) => {
  return (
    <div className="btnImport" id={'btnImport-' + props.identifier}>
          <span className="d-none">
            <input onChange={(event) => props.onUpdateInput(event)} type="file" name="file" value={props.selectedFileName}
                   accept={props.authorizedFiles.join((','))} id={'file-' + props.identifier}/>
          </span>
      <label htmlFor={'file-' + props.identifier} id={'label-' + props.identifier}
             className={'label-file white border-0 py-2 px-3 cursor-pointer m-0 importButton label-file-' +
               props.marquageNom + '-' + props.surfaceId}
             style={{background: getBoutiqueColor()}}>
        <Icons icon="file_upload" size={25} color="#fff" className="mr-2"/>
        <span className={"d-flex align-items-center"}>Importer&nbsp;<span className="hide-for-small">une image</span></span>
      </label>
    </div>
  );
}